const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Microsoft Teams Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('MicrosoftTeams', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/microsoft-teams/:type/:subresource', null, {
    createIntegration: {params: {type: 'meetings', subresource: 'integrate'}, method: 'POST', isArray: false},
    removeIntegration: {params: {type: 'meetings', subresource: 'remove-integration'}, method: 'POST', isArray: false},
    checkExists: {params: {type: 'meetings', subresource: 'exists'}, method: 'GET', isArray: false},
    uploadApp: {params: {type: 'upload-app'}, method: 'POST', isArray: false}
  });
}]);